import { DELETE_MEAL_FROM_MEALPLAN } from './actionTypes';

export default (meal_id: String) => ({
  type: DELETE_MEAL_FROM_MEALPLAN,
  payload: {
    meal_id
  },
});